module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_1.f470fe15.png";